import React, {useEffect, useState, useMemo} from "react";
import {useSelector} from "react-redux";
import getMyData, {
    getICCategoryOptions,
    getICTypeOptions,
    getInvoiceTypesOptions,
    getMyDataRowTypes,
    getVatExpenseClassificationType
} from "../../../../_helpers/sharedmydata";
import {toast} from "react-toastify";
import {
    addProductEditAllVariants,
    addProductEditVariant,
    resetNewVariantProps,
    resetTempEditProductProperties,
    setAllCheckedEditVariants,
    setEditProductCodes,
    setEditProductDisplayedVariants,
    setEditProductsMyData,
    setEditSelectedVariantsRows,
    setEditVariantIds,
    setEditVariantSearchTerm,
    setNewVariant, setProductMovementsReportDataByBalance,
    setProductsSelectedCategoryData,
    setSelectedEditProduct,
    setTempEditProductProperties,
    updateProductEditVariants
} from "../../../../_reducers/DataPanel/Products/productsSlice";
import {
    findObjectFromArrayOfObjects,
    getObjectFromArrayOfObjects
} from "../../../../_helpers/helperFunctions";
import {
    checkPermission,
    getDefaultOptionByValue,
    getGeneratedMaskCode,
    getMaskCodePrefix,
    getMaskCodeWithNewPrefix,
    getOptionsByData,
    isEmpty,
    isValidNumber, normalizeText,
    productCategoryOptions, quickClone,
    removeEmptyValues, specialProductTypeOptions,
    vatIncludedOptions
} from "../../../../_helpers/commonFunctions";
import {Button, Col, FormLabel, Modal, Row} from "react-bootstrap";
import Input from "../../../common/Input";
import LogTable from "../../../primer/LogTable";
import BetterCheckBox from "../../../common/BetterCheckBox";
import Dropdown from "../../../primer/Dropdown";
import AccountingBox from "../../../primer/AccountingBox";
import EditableTable from "../../../primer/Editable-Table";
import TextArea from "../../../common/TextArea";
import {setSaveEditProduct} from "../../../../_reducers/activitySlice";
import Checkbox from "../../../common/CheckBox";
import ModalInstructions from "../../../primer/POPUP-COMPONENTS/Instructions";
import {fuelCodes} from "../../../../_data/mydata/fuelCodes";
import {packagingTypes} from "../../../../_data/mydata/packagingTypes";
import {openProductMovementsReport} from "../../../../_helpers/tabOpeners";
import axios from "axios";
import useTaggedDispatch from "../../../../hooks/useTaggedDispatch";
import {useTranslation} from "../../../../hooks/useTranslation";

export const ProductsEditGeneral = ({tabKey}) => {
    const dispatch = useTaggedDispatch({tabKey});
    const editProduct = useSelector((state) => state.PRODUCTS_DATA.selectedEditProduct[tabKey]);

    const {t} = useTranslation();
    const invoiceTypes = getInvoiceTypesOptions("products");
    const icCategory = getICCategoryOptions();
    const icType = getICTypeOptions();
    const myDataRowTypes = getMyDataRowTypes();
    const vatExpenseTypes = getVatExpenseClassificationType();
    const ACTIVITY = useSelector((state) => state.ACTIVITY);
    const PRODUCTS_DATA = useSelector((state) => state.PRODUCTS_DATA);
    const PRODUCTS_CATEGORY = useSelector((state) => state.PRODUCTS_CATEGORY.categories);
    const subCategories = useSelector((state) => state.PRODUCTS_CATEGORY.subCategories);
    const vatTaxes = getMyData({type: 'vat'});
    const SETTINGS = useSelector(state => state.SETTINGS);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const zeroVatReasonOptions = getMyData({type: 'zerovatreason'});
    const measurementUnitOptions = getMyData({type: 'mu', settings: SETTINGS});
    const fuelCodesOptions = [{value: "", label: "Κενό"}, ...fuelCodes];
    const invoiceDetailTypeOptions = [{value: "", label: "Κενό"}, {value: "1", label: "Εκκαθάριση Πωλήσεων Τρίτων"}, {value: "2", label: "Αμοιβή από Πωλήσεις Τρίτων"}];
    const packagingTypesOptions = useMemo(() => [{ value: "", label: "Κενό" }, ...packagingTypes], [packagingTypes]);
    const [showCategoryConfirmation, setShowCategoryConfirmation] = useState(false);
    const [tempCatValue, setTempCatValue] = useState({});
    const permissionData = JSON.parse(localStorage.getItem("permissions"));

    // For editable table re-rendering
    const [incrKey, setIncrKey] = useState(0);
    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [editProduct.mydata])

    const [incrKey2, setIncrKey2] = useState(0);
    useEffect(() => {
        setIncrKey2(incrKey2 + 1);
    }, [editProduct.productProperties]);

    const inventoryInstallationsColumns = [
        {name: "No", width: "10%", field: "no", editable: false},
        {
            name: t('ProductsNewGeneralEdit.table4.type'),
            field: "type",
            editable: false,
            width: "30%",
            inputType: {type: "dropdown", config: {searchEnable: true}}
        },
        {
            name: t('ProductsNewGeneralEdit.table4.address'),
            field: "address",
            editable: false,
            width: "30%",
            inputType: {type: "text"}
        },
        {
            name: t('ProductsNewGeneralEdit.table4.inventory'),
            field: "inventory",
            editable: false,
            width: "20%",
            inputType: {type: "number", config: {searchEnable: true}}
        },
    ];
    const productsColumns = [
        {
            name: t('ProductsNewGeneral.table.rowType'),
            field: "rowType",
            width: "10%",
            editable: true,
            inputType: {type: 'select', options: myDataRowTypes}
        },
        {
            name: t('ProductsNewGeneralEdit.table.invoiceType'),
            field: "invoiceType",
            editable: true,
            width: "30%",
            inputType: {type: 'select', multiselect: true, options: invoiceTypes}
        },
        {
            name: t('ProductsNewGeneralEdit.table.category'),
            field: "category",
            editable: true,
            width: "20%",
            inputType: {type: 'select', options: icCategory}
        },
        {
            name: t('ProductsNewGeneralEdit.table.type'),
            field: 'type',
            editable: true,
            width: "20%",
            inputType: {type: 'select', options: icType}
        },
        {
            name: t('ProductsNewGeneral.table.vatExpenseType'),
            field: 'vatExpenseType',
            editable: true,
            width: "20%",
            inputType: {type: 'select', options: vatExpenseTypes}
        }
    ];

    const propertiesColumns = [
        {
            name: 'Όνομα Ιδιότητας',
            field: 'name',
            editable: true,
            width: "20%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: 'Τιμές Ιδιότητας',
            field: 'values',
            editable: true,
            width: "80%",
            inputType: {
                type: 'text',
            }
        },
    ];

    const propertiesInstructions = {
        title: "Οδηγίες Εισαγωγής Ιδιοτήτων",
        content: "<div>Εισάγετε ιδιότητες ειδών χωρίζοντάς τις τιμές με κόμμα(,).<br><br>Καθορίστε αυξομειώσεις τιμής σε συγκεκριμένες παραλλαγές με ανω-κάτω τελεία(:)<br><br><u>Παράδειγμα</u><br>Όνομα Ιδιότητας: Χρώμα<br>Τιμές Ιδιότητας: μαύρο,κόκκινο:3,κίτρινο:-3,μπλε</div>"
    };

    const setSelectedCategoryData = (categoryId) => {
        const selected = getObjectFromArrayOfObjects(PRODUCTS_CATEGORY, categoryId, '_id')['0'];
        dispatch(setProductsSelectedCategoryData(selected));
        // Update the Taxes to current product.
        const categoryTaxesData = selected.taxes && (selected.taxes !== 'undefined') ? JSON.parse(selected.taxes) : '';
        const taxesData = {
            category: categoryId ? categoryId : '',
            categoryName: selected.title || "",
            categoryMaskCodePrefix: selected.maskCodePrefix ? selected.maskCodePrefix : 'PC',
            vat: categoryTaxesData.vat ? categoryTaxesData.vat : '',
            vatReason: categoryTaxesData.vatreason ? categoryTaxesData.vatreason : '',
            otherTaxes: categoryTaxesData.othertaxes ? categoryTaxesData.othertaxes : '',
            withholdTax: categoryTaxesData.witholdtaxes ? categoryTaxesData.witholdtaxes : '',
            stamp: categoryTaxesData.stamp ? categoryTaxesData.stamp : '',
            fees: categoryTaxesData.fees ? categoryTaxesData.fees : '',
            accountingCode: selected.accountingCode ? selected.accountingCode : '',
            netAmountAccountingCode: selected.netAmountAccountingCode ? selected.netAmountAccountingCode : '',
            vatAccountingCode: selected.vatAccountingCode ? selected.vatAccountingCode : '',
            taxAccountCode: selected.taxAccountCode ? selected.taxAccountCode : '',
            accountingCodeSales: selected.accountingCodeSales ? selected.accountingCodeSales : '',
            netAmountAccountingCodeSales: selected.netAmountAccountingCodeSales ? selected.netAmountAccountingCodeSales : '',
            vatAccountingCodeSales: selected.vatAccountingCodeSales ? selected.vatAccountingCodeSales : '',
            taxAccountCodeSales: selected.taxAccountCodeSales ? selected.taxAccountCodeSales : '',
            accountingCodeBuys: selected.accountingCodeBuys ? selected.accountingCodeBuys : '',
            netAmountAccountingCodeBuys: selected.netAmountAccountingCodeBuys ? selected.netAmountAccountingCodeBuys : '',
            vatAccountingCodeBuys: selected.vatAccountingCodeBuys ? selected.vatAccountingCodeBuys : '',
            taxAccountCodeBuys: selected.taxAccountCodeBuys ? selected.taxAccountCodeBuys : '',
            accountingNonDeductibleVAT: selected.accountingNonDeductibleVAT ? selected.accountingNonDeductibleVAT : '',
        }

        // Update my data to current product
        let combinedData = {...taxesData}
        if (selected.mydata && selected.mydata.length > 0) {
            const categoryMyData = selected.mydata ? JSON.parse(selected.mydata) : {};
            const myData = {mydata: categoryMyData}

            combinedData = {...myData, ...taxesData}
        }
        let tempProductCode = getGeneratedMaskCode('product', categoryId, PRODUCTS_CATEGORY)
        combinedData.categoryMaskCodePrefix = getMaskCodePrefix(selected.maskCode);
        combinedData.code = getMaskCodeWithNewPrefix(tempProductCode, combinedData.categoryMaskCodePrefix);
        combinedData.subCategory = undefined;
        combinedData.subCategoryName = undefined;
        dispatch(setSelectedEditProduct({...editProduct, ...combinedData}));
    }

    const handleConfirmCategory = () => {
        setSelectedCategoryData(tempCatValue.new);
        setShowCategoryConfirmation(false);
    }

    const propertiesActions = {

        insert: (e, data) => {
            if (isEmpty(data.value)) return;

            let tempEditProperty = structuredClone(PRODUCTS_DATA.tempEditProductProperties);
            if (data.name) data.name = data.name.trim();
            if(data.values) data.values = data.values.replace(/\s+/g, '');
            tempEditProperty[data.field] = data.value;
            if (isEmpty(tempEditProperty.name) || isEmpty(tempEditProperty.values)) {
                dispatch(setTempEditProductProperties(tempEditProperty));
            } else {
                let productProperties = Object.assign([], editProduct.productProperties);
                if(productProperties.filter((prop) => prop.name === tempEditProperty.name).length !== 0) return toast.error("Διπλότυπη Ιδιότητα.");
                productProperties.push(tempEditProperty);
                dispatch(resetTempEditProductProperties());
                dispatch(resetNewVariantProps());
                dispatch(setSelectedEditProduct({...editProduct, productProperties: productProperties}));
                if(!ACTIVITY.saveEditProduct) dispatch(setSaveEditProduct(true));
            }
        },
        update: (data, id, rowIndex) => {
            if(!ACTIVITY.saveEditProduct) dispatch(setSaveEditProduct(true));
            let productProperties = structuredClone(editProduct.productProperties);
            if (data.name) data.name = data.name.trim();
            if (data.values) data.values = data.values.replace(/\s+/g, '');
            if (productProperties.filter((prop, index) => index !== rowIndex && prop.name === data.name).length !== 0) return toast.error("Διπλότυπη Ιδιότητα.");
            productProperties[rowIndex] = {...productProperties[rowIndex], ...data};
            dispatch(resetNewVariantProps());
            dispatch(setSelectedEditProduct({...editProduct, productProperties: productProperties}));
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!ACTIVITY.saveEditProduct) dispatch(setSaveEditProduct(true));
            let productProperties = structuredClone(editProduct.productProperties);
            const deleted = productProperties.splice(rowIndex, 1);

            let canBeDeleted = true;
            editProduct.variants.forEach(variant => {
                if (JSON.stringify(variant.properties).includes(deleted[0].name)) canBeDeleted= false;
            });
            if (!canBeDeleted) {
                toast.error("Η ιδιότητα δε μπορει να διαγραφεί καθώς υπάρχει σε παραλλαγή του είδους.");
                return;
            }
            dispatch(resetNewVariantProps());
            dispatch(setSelectedEditProduct({...editProduct, productProperties: productProperties}));
        }
    }

    const parentMydataActions = {
        insert: (e, data) => {
            if (!ACTIVITY.saveEditProduct) dispatch(setSaveEditProduct(true));
            let tempPcMyData = Object.assign({}, PRODUCTS_DATA.editProductsMyData);
            if (e.key !== "Enter") {
                tempPcMyData[data.field] = data.value;
                dispatch(setEditProductsMyData(tempPcMyData)); // Update redux my data values
            }
            if (tempPcMyData.rowType !== '' || tempPcMyData.invoiceType !== '' || tempPcMyData.category !== '' || tempPcMyData.type !== '') {
                let updateNewPcMydata = Object.assign({}, tempPcMyData);

                updateNewPcMydata.id = editProduct.mydata.length + 1;
                const tempMydata = [...editProduct.mydata, updateNewPcMydata];
                dispatch(setSelectedEditProduct({...editProduct, ...{mydata: tempMydata}}));  // update products mydata
                dispatch(setEditProductsMyData(PRODUCTS_DATA.newProductsMyDataInitialValue)); // Reset new category mydata
            }

            // Add on press enter
            if (e.key === "Enter" && data.field !== 'add') {
                let updateNewPcMydata = Object.assign({}, PRODUCTS_DATA.editProductsMyData);
                updateNewPcMydata.id = editProduct.mydata.length + 1;
                const tempMydata = [...editProduct.mydata, updateNewPcMydata];
                dispatch(setSelectedEditProduct({...editProduct, ...{mydata: tempMydata}}));  // update products mydata
                dispatch(setEditProductsMyData(PRODUCTS_DATA.newProductsMyDataInitialValue)); // Reset new category mydata
            }
            // Fix allow empty row insert on check box click
            if (e.key === "Enter" && data.field === 'add') {
                let updateNewPcMydata = Object.assign({}, PRODUCTS_DATA.editProductsMyData);
                updateNewPcMydata.id = editProduct.mydata.length + 1;
                updateNewPcMydata.rowType = "";
                updateNewPcMydata.invoiceType = "";
                updateNewPcMydata.category = "";
                updateNewPcMydata.type = "";
                updateNewPcMydata.vatExpenseType = "";
                const tempMydata = [...editProduct.mydata, updateNewPcMydata];
                dispatch(setSelectedEditProduct({...editProduct, ...{mydata: tempMydata}}));  // update products mydata
                dispatch(setEditProductsMyData(PRODUCTS_DATA.newProductsMyDataInitialValue)); // Reset new category mydata
            }
        },
        update: (data, id, rowIndex) => {
            if(!ACTIVITY.saveEditProduct) dispatch(setSaveEditProduct(true));
            let cloneMyData = structuredClone(editProduct.mydata);
            cloneMyData[rowIndex] = {...cloneMyData[rowIndex], ...data}
            if (data.invoiceType) {
                cloneMyData[rowIndex].category = "";
                cloneMyData[rowIndex].type = "";
                cloneMyData[rowIndex].vatExpenseType = "";
            } else if (data.category) {
                cloneMyData[rowIndex].type = "";
                cloneMyData[rowIndex].vatExpenseType = "";
            } else if (data.type) {
                cloneMyData[rowIndex].vatExpenseType = "";
            }
            dispatch(setSelectedEditProduct({...editProduct, mydata: cloneMyData}));  // update products mydata
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if(!ACTIVITY.saveEditProduct) dispatch(setSaveEditProduct(true));
            let clonedMyData = structuredClone(editProduct.mydata);
            clonedMyData.splice(rowIndex, 1);
            dispatch(setSelectedEditProduct({...editProduct, mydata: clonedMyData}));
        },
    }

    const handleOnChange = (e, type, compName) => {
        if (!ACTIVITY.saveEditProduct) dispatch(setSaveEditProduct(true));

        if (type === "checkbox") {
            if (compName === "isActive") {
                const activity = e.target.checked === true ? "active" : "inActive";
                dispatch(setSelectedEditProduct({...editProduct, isActive: activity}))
            } else if (compName === "showAlternativeNameOnPrint") {
                dispatch(setSelectedEditProduct({...editProduct, showAlternativeNameOnPrint: String(e.target.checked)}))
            } else if (compName === "showAlternativeCodeOnPrint") {
                dispatch(setSelectedEditProduct({...editProduct, showAlternativeCodeOnPrint: String(e.target.checked)}))
            } else if (compName === "notVAT195") {
                dispatch(setSelectedEditProduct({...editProduct, notVAT195: String(e.target.checked)}))
            } else if (compName === "discountOption") {
                dispatch(setSelectedEditProduct({...editProduct, discountOption: e.target.checked}))
            }
        } else if (type === "dropdown") {
            if (compName === "category") {
                setIncrKey(incrKey + 1);
                setShowCategoryConfirmation(true);
                setTempCatValue({new: e.value, old: editProduct.category});
            } else if (compName === "subCategory") {
                let newProductData = quickClone(editProduct);
                setIncrKey(incrKey + 1);
                const value = e.value;

                if (value && value !== "") {
                    newProductData["subCategory"] = value;
                    const subCat = subCategories.find((subCat) => subCat._id === value);
                    if (subCat) {
                        newProductData["subCategoryName"] = subCat.title;
                        newProductData["mydata"] = JSON.parse(subCat?.mydata || "[]");
                        const subCatTaxes = JSON.parse(subCat?.taxes || "{}");
                        if (Object.keys(subCatTaxes).length > 0) {
                            newProductData = {
                                ...newProductData,
                                vat: subCatTaxes.vat ? subCatTaxes.vat : '',
                                vatReason: subCatTaxes.vatreason ? subCatTaxes.vatreason : '',
                                otherTaxes: subCatTaxes.othertaxes ? subCatTaxes.othertaxes : '',
                                withholdTax: subCatTaxes.witholdtaxes ? subCatTaxes.witholdtaxes : '',
                                stamp: subCatTaxes.stamp ? subCatTaxes.stamp : '',
                                fees: subCatTaxes.fees ? subCatTaxes.fees : '',
                            }
                        }

                        const inheritKeys = [
                            "accountingCode", "netAmountAccountingCode", "vatAccountingCode",
                            "taxAccountCode", "accountingNonDeductibleVAT", "accountingCodeSales",
                            "netAmountAccountingCodeSales", "vatAccountingCodeSales",
                            "taxAccountCodeSales", "accountingCodeBuys", "netAmountAccountingCodeBuys",
                            "vatAccountingCodeBuys", "taxAccountCodeBuys"
                        ];
                        for (const key of inheritKeys) {
                            newProductData[key] = subCat[key] || "";
                        }
                    }
                } else {
                    newProductData["subCategory"] = "";
                    newProductData["subCategoryName"] = "";
                }
                dispatch(setSelectedEditProduct(newProductData));
            } else if (compName === "vat") {
                dispatch(setSelectedEditProduct({...editProduct, vat: e.value}))
            } else if (compName === "vatReason") {
                dispatch(setSelectedEditProduct({...editProduct, vatReason: e.value}))
            } else if (compName === "measurementUnit") {
                dispatch(setSelectedEditProduct({...editProduct, measurementUnit: e.value}))
            } else if (compName === "vatIncluded") {
                dispatch(setSelectedEditProduct({...editProduct, vatIncluded: String(e.value)}))
            } else if (compName === "vatIncludedBuy") {
                dispatch(setSelectedEditProduct({...editProduct, vatIncludedBuy: String(e.value)}))
            } else if (compName === "fuelCode") {
                dispatch(setSelectedEditProduct({...editProduct, fuelCode: String(e.value)}))
            } else if (compName === "invoiceDetailType") {
                dispatch(setSelectedEditProduct({...editProduct, invoiceDetailType: String(e.value)}))
            } else if (compName === "specialOption") {
                dispatch(setSelectedEditProduct({...editProduct, specialOption: String(e.value)}))
            } else if (compName === "packagingType") {
                dispatch(setSelectedEditProduct({...editProduct, packagingType: String(e.value)}))
            }
        } else if (type === "input") {
            if (compName === "name") {
                dispatch(setSelectedEditProduct({...editProduct, name: e.target.value}))
            } else if (compName === "alternateName") {
                dispatch(setSelectedEditProduct({...editProduct, alternateName: e.target.value}))
            } else if (compName === "alternateCode") {
                dispatch(setSelectedEditProduct({...editProduct, alternateCode: e.target.value}))
            } else if (compName === "barcode") {
                dispatch(setSelectedEditProduct({...editProduct, barcode: e.target.value}))
            } else if (compName === "price") {
                dispatch(setSelectedEditProduct({...editProduct, price: e.target.value}))
            } else if (compName === "buyPrice") {
                dispatch(setSelectedEditProduct({...editProduct, buyPrice: e.target.value}))
            } else if (compName === "cpvCode") {
                dispatch(setSelectedEditProduct({...editProduct, cpvCode: e.target.value}))
            } else if (compName === "taricNumber") {
                dispatch(setSelectedEditProduct({...editProduct, taricNumber: e.target.value}))
            } else if (compName === "packagingQuantity") {
                dispatch(setSelectedEditProduct({...editProduct, packagingQuantity: e.target.value}))
            } else if (compName === "otherPackagingTypeTitle") {
                dispatch(setSelectedEditProduct({...editProduct, otherPackagingTypeTitle: e.target.value}))
            }
        } else if (type === "textarea") {
            if (compName === "notes") {
                dispatch(setSelectedEditProduct({...editProduct, notes: e.target.value}))
            }
        }
    }

    const handleClickOpenProductsMovementsReport = () => {
        dispatch(setProductMovementsReportDataByBalance({
            _id: editProduct._id,
            productName: editProduct.name
        }));
        dispatch(openProductMovementsReport(TABS_DATA));
    }

    const availableSubCategories = !isEmpty(editProduct.category)
        ?
        [
            {value: "", label: "Κενό"},
            ...subCategories.filter((el) => el.parentCategory === editProduct.category).map((subCat) => {
                return {
                    value: subCat._id,
                    label: subCat.title,
                }
            })
        ] : [];

    return (
        <React.Fragment>
            <Row className="position-relative border-bottom mb-3">
                <Col xs="12" md="12" className="d-flex align-items-center justify-content-end">
                    {editProduct.measurementUnit !== "4" && editProduct.isTaxLine !== "true" && (
                        <div className="inline-field d-flex align-items-center mr-5">
                            <Button size={"sm"} className={"mr-3"} onClick={() => handleClickOpenProductsMovementsReport()}>
                                Προβολή καρτέλας είδους
                            </Button>
                            <Input
                                className={"mb-4"}
                                name="productInventoryBalance"
                                label={t('ProductsNewGeneralEdit.invetoryBalance')}
                                value={editProduct.inventoryBalance ? editProduct.inventoryBalance : 0}
                                disabled={true}
                            />
                        </div>
                    )}
                    <div className="d-flex justify-content-end mb-3">
                        <label htmlFor="product-active" className="mb-0 mr-2">{t('ProductsNewGeneralEdit.productActive')}</label>
                        <BetterCheckBox
                            className="mb-2"
                            name="isActive"
                            key={Math.random()}
                            checked={editProduct.isActive === "active"}
                            onChange={(e) => handleOnChange(e, "checkbox", "isActive")}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs="12" md="4">
                    <Dropdown
                        name={"category"}
                        label={t('ProductsNewGeneralEdit.productCategory.productCategory')}
                        key={Math.random()}
                        defaultValue={getDefaultOptionByValue(productCategoryOptions(PRODUCTS_CATEGORY), editProduct.category, 'value', 'label', 'value')}
                        options={productCategoryOptions(PRODUCTS_CATEGORY)}
                        onChange={(e) => handleOnChange(e, "dropdown", "category")}
                    />
                </Col>
                {availableSubCategories.length > 1 && (
                    <Col md={4}>
                        <Dropdown
                            name={"subCategory"}
                            label={"Υποκατηγορία"}
                            key={Math.random()}
                            defaultValue={availableSubCategories.find((el) => el.value === editProduct.subCategory)}
                            options={availableSubCategories}
                            onChange={(e) => handleOnChange(e, 'dropdown', 'subCategory')}
                        />
                    </Col>
                )}
            </Row>
            <Row className="mb-3">
                <Col xs="12" md="6">
                    <Input
                        name="name"
                        charlimit={500}
                        required={true}
                        autoComplete={"off"}
                        label={t('ProductsNewGeneralEdit.productName.productName')}
                        placeholder={t('ProductsNewGeneralEdit.productName.placeholder')}
                        value={editProduct.name}
                        onChange={(e) => handleOnChange(e, "input", "name")}
                    />
                    {isEmpty(editProduct.name) &&
                        <span className="text-danger">{t('ProductsNewGeneral.productName.required')}</span>}
                </Col>
                <Col xs="12" md="4">
                    <Input
                        name="alternateName"
                        autoComplete={"off"}
                        label={t('ProductsNewGeneralEdit.alternativeName.alternativeName')}
                        placeholder={t('ProductsNewGeneralEdit.alternativeName.placeholder')}
                        value={editProduct.alternateName}
                        onChange={(e) => handleOnChange(e, "input", "alternateName")}
                    />
                </Col>
                <Col md={2}>
                    <BetterCheckBox
                        className={"mt-3"}
                        name={"showAlternativeNameOnPrint"}
                        text={"Προβολή εναλλακτικού ονόματος στα παραστατικά"}
                        checked={editProduct?.showAlternativeNameOnPrint === "true"}
                        onChange={(e) => handleOnChange(e, "checkbox", "showAlternativeNameOnPrint")}
                    />
                </Col>
            </Row>
            <Row className="mb-3">
                <Col xs="12" md="2">
                    <Input
                        name="code"
                        autoComplete={"off"}
                        label={t('ProductsNewGeneralEdit.productCode.productCode')}
                        placeholder={t('ProductsNewGeneralEdit.productCode.placeholder')}
                        disabled={true}
                        value={getMaskCodeWithNewPrefix(editProduct.code, editProduct.categoryMaskCodePrefix)}
                    />
                </Col>
                <Col xs="12" md="2">
                    <Input
                        name="alternateCode"
                        autoComplete={"off"}
                        label={t('ProductsNewGeneralEdit.alternativeCode.alternativeCode')}
                        placeholder={t('ProductsNewGeneralEdit.alternativeCode.placeholder')}
                        value={editProduct.alternateCode}
                        onChange={(e) => handleOnChange(e, "input", "alternateCode")}
                    />
                </Col>
                <Col md={2}>
                    <BetterCheckBox
                        className={"mt-3"}
                        name={"showAlternativeCodeOnPrint"}
                        text={"Προβολή εναλλακτικού κωδικού στα παραστατικά"}
                        checked={editProduct?.showAlternativeCodeOnPrint === "true"}
                        onChange={(e) => handleOnChange(e, "checkbox", "showAlternativeCodeOnPrint")}
                    />
                </Col>
                <Col xs="12" md="3">
                    <Input
                        name="barcode"
                        autoComplete={"off"}
                        label={"EAN Barcode"}
                        placeholder={"EAN Barcode"}
                        value={editProduct.barcode}
                        onChange={(e) => handleOnChange(e, "input", "barcode")}
                    />
                </Col>
                {checkPermission("custom-b2g", permissionData) && (
                    <Col md={3}>
                        <Input
                            name={"cpvCode"}
                            label={"Κωδικός CPV (Απαραίτητο για δημόσιες συμβάσεις)"}
                            value={editProduct.cpvCode}
                            placeholder={"Προσθέστε Κωδικό CPV"}
                            onChange={(e) => handleOnChange(e, "input", "cpvCode")}
                        />
                        <Button size={"sm"} title={"Βοήθεια"} style={{position: "absolute", right: "17px", top: "30px", padding: "5px"}}
                                onClick={() => window.open("https://cerpp.eprocurement.gov.gr/cpv/main/", "_blank")}><i className="fas fa-circle-question"></i></Button>
                    </Col>
                )}
            </Row>
            <Row className="mb-3">
                <Col xs="12" md={"3"}>
                    <Dropdown
                        name={"vat"}
                        required={true}
                        label={t('ProductsNewGeneralEdit.vat.vat')}
                        disabled={editProduct.isTaxLineWithoutVat === "true"}
                        key={Math.random()}
                        defaultValue={getDefaultOptionByValue(vatTaxes, editProduct.vat, 'value', 'label', 'value')}
                        options={vatTaxes}
                        onChange={(e) => handleOnChange(e, "dropdown", "vat")}
                        className={"mb-0"}
                    />
                    {isEmpty(editProduct.vat) &&
                        <span className="text-danger">{t('ProductsNewGeneral.vat.required')}</span>}
                </Col>
                {editProduct.vat === "0" && (
                    <Col xs="12" md="3">
                        <Dropdown
                            name={"vatReason"}
                            required={true}
                            label={t('ProductsNewGeneralEdit.0VatReason.0VatReason')}
                            key={Math.random()}
                            defaultValue={getDefaultOptionByValue(zeroVatReasonOptions, editProduct.vatReason, 'value', 'label', 'value')}
                            options={zeroVatReasonOptions}
                            onChange={(e) => handleOnChange(e, "dropdown", "vatReason")}
                            className={"mb-0"}
                        />
                        {isEmpty(editProduct.vatReason) &&
                            <span className="text-danger">{t('ProductsNewGeneral.0VatReason.required')}</span>}
                    </Col>
                )}
                <Col xs="12" md="3">
                    <Dropdown
                        name={"measurementUnit"}
                        required={true}
                        label={t('ProductsNewGeneralEdit.measurementUnit.measurementUnit')}
                        key={Math.random()}
                        defaultValue={getDefaultOptionByValue(measurementUnitOptions, String(editProduct.measurementUnit), 'value', 'label', 'value')}
                        options={measurementUnitOptions}
                        onChange={(e) => handleOnChange(e, "dropdown", "measurementUnit")}
                        className={"mb-0"}
                    />
                    {isEmpty(editProduct.measurementUnit) &&
                        <span className="text-danger">{t("ProductsNewGeneral.measurementUnit.required")}</span>}
                </Col>
                <Col xs={"12"} md={"3"}>
                    <Dropdown
                        name={"fuelCode"}
                        label={"Κωδικός Καυσίμου"}
                        key={Math.random()}
                        defaultValue={fuelCodesOptions.find((el) => el.value === editProduct.fuelCode)}
                        options={fuelCodesOptions}
                        onChange={(e) => handleOnChange(e, "dropdown", "fuelCode")}
                        className={"mb-0"}
                    />
                </Col>
                <Col xs={"12"} md={"3"}>
                    <Dropdown
                        name={"invoiceDetailType"}
                        label={"Επισήμανση στο παραστατικό"}
                        key={Math.random()}
                        defaultValue={invoiceDetailTypeOptions.find((el) => el.value === editProduct.invoiceDetailType)}
                        options={invoiceDetailTypeOptions}
                        onChange={(e) => handleOnChange(e, "dropdown", "invoiceDetailType")}
                        className={"mb-0"}
                    />
                    {(editProduct.mydata.some((row) => row.invoiceType === "1.5") && !editProduct?.invoiceDetailType) &&
                        <span className="text-danger">Απαιτείται η επισήμανση στο παραστατικό.</span>}
                </Col>
                <Col xs={"12"} md={"3"}>
                    <Dropdown
                        name={"specialOption"}
                        label={"Ειδικός τύπος είδους"}
                        options={specialProductTypeOptions()}
                        defaultValue={specialProductTypeOptions().find((el) => el.value === editProduct.specialOption)}
                        onChange={(e) => handleOnChange(e, "dropdown", "specialOption")}
                        className={"mb-0"}
                    />
                </Col>
                {editProduct.measurementUnit !== "4" && (
                    <Col xs={"12"} md={"3"}>
                        <Input
                            name={"taricNumber"}
                            autoComplete={"off"}
                            label={"Κωδικός Taric"}
                            placeholder={"Κωδικός Taric"}
                            value={editProduct.taricNumber}
                            charLimit={10}
                            onChange={(e) => handleOnChange(e, "input", "taricNumber")}
                        />
                    </Col>
                )}
                <Col xs={"12"} md={3}>
                    <div style={{marginTop: "33px"}}>
                        <BetterCheckBox
                            name={"discountOption"}
                            text={"Δικαίωμα Έκπτωσης (Φορολογικό)"}
                            checked={editProduct?.discountOption}
                            onChange={(e) => handleOnChange(e, "checkbox", "discountOption")}
                        />
                    </div>
                </Col>
            </Row>
            <Row className={"mt-3"}>
                <Col xs="12" md="2">
                    <label>{t('General.preferredSalePrice')}</label>
                    <AccountingBox
                        name={"price"}
                        placeholder={t('Placeholders.preferredSalePrice')}
                        value={editProduct.price}
                        defaultValue={editProduct.price}
                        onChange={(e) => handleOnChange(e, "input", "price")}
                    />
                </Col>
                <Col xs="12" md="2">
                    <Dropdown
                        name={"vatIncluded"}
                        label={t('ProductsNewGeneralEdit.vatIncluded')}
                        key={Math.random()}
                        defaultValue={vatIncludedOptions().find((el) => String(el.value) === String(editProduct.vatIncluded))}
                        options={vatIncludedOptions()}
                        onChange={(e) => handleOnChange(e, "dropdown", "vatIncluded")}
                        className={"mb-0"}
                    />
                </Col>
                {checkPermission("buys-buy/new-write", permissionData) && (
                    <React.Fragment>
                        <Col xs="12" md="2">
                            <label>{t('General.preferredBuyPrice')}</label>
                            <AccountingBox
                                name={"buyPrice"}
                                placeholder={t('Placeholders.preferredBuyPrice')}
                                value={editProduct.buyPrice}
                                defaultValue={editProduct.buyPrice}
                                onChange={(e) => handleOnChange(e, "input", "buyPrice")}
                            />
                        </Col>
                        <Col xs="12" md="2">
                            <Dropdown
                                name={"vatIncludedBuy"}
                                label={t('ProductsNewGeneralEdit.vatIncluded')}
                                key={Math.random()}
                                defaultValue={vatIncludedOptions().find((el) => String(el.value) === String(editProduct.vatIncludedBuy))}
                                options={vatIncludedOptions()}
                                onChange={(e) => handleOnChange(e, "dropdown", "vatIncludedBuy")}
                                className={"mb-0"}
                            />
                        </Col>
                    </React.Fragment>
                )}
                <Col xs={"12"} md={"3"}>
                    <div style={{marginTop: "32px"}}>
                        <BetterCheckBox
                            name={"notVAT195"}
                            text={"Μη συμμετοχή στο έντυπο ΦΠΑ (έσοδα - εκροές)"}
                            checked={editProduct?.notVAT195 === "true"}
                            onChange={(e) => handleOnChange(e, "checkbox", "notVAT195")}
                        />
                    </div>
                </Col>
            </Row>
            <hr/>
            <Row>
                <EditableTable
                    tableName="New Product My Data" // Do not change name
                    showErrors={editProduct.mydata && editProduct.mydata.length === 0}
                    showErrorMessage={t('ProductsNewGeneralEdit.errorMessage')}
                    key={"PEMD" + incrKey}
                    allowActions={true}
                    onUpdate={parentMydataActions}
                    heading="My Data"
                    allowInsertRow={true}
                    enableNewRowCheckbox={true}
                    columns={productsColumns}
                    data={editProduct.mydata}
                />
            </Row>
            {checkPermission("products-products/edit-variants-write", permissionData) && (
                <React.Fragment>
                    <hr/>
                    <Row>
                        <Col>
                            <div className="text-muted mb-2 d-flex align-items-center">
                                <i>{t("ProductVariants.productProperties")}</i>
                                <div className="ml-2">
                                    <ModalInstructions data={propertiesInstructions} />
                                </div>
                            </div>
                            <EditableTable
                                tableName="Edit Product Properties" // Do not change name
                                key={`EPP-${incrKey2}`}
                                allowActions={true}
                                onUpdate={propertiesActions}
                                allowInsertRow="true"
                                columns={propertiesColumns}
                                enableNewRowCheckbox={true}
                                data={editProduct.productProperties}/>
                        </Col>
                    </Row>
                </React.Fragment>
            )}
            <hr/>
            <Row>
                <Col>
                    <div className="text-muted mb-2 d-flex align-items-center">{t('ProductsNewGeneral.packagingDetails')}</div>
                    <Row>
                        <Col xs="12" md="4">
                            <Input
                                name="packagingQuantity"
                                type="number"
                                label={t('ProductsNewGeneral.packagingQuantity')}
                                placeholder={t('ProductsNewGeneral.packagingQuantity')}
                                value={editProduct.packagingQuantity}
                                onChange={(e) => handleOnChange(e, "input", "packagingQuantity")}
                            />
                        </Col>
                        <Col xs="12" md="4">
                            <Dropdown
                                name={"packagingType"}
                                label={"Είδος Συσκευασίας"}
                                className={"mb-2"}
                                options={packagingTypesOptions}
                                defaultValue={packagingTypesOptions.find((el) => el.value === editProduct.packagingType)}
                                key={Math.random()}
                                onChange={(e) => handleOnChange(e, "dropdown", "packagingType")}
                            />
                        </Col>
                        {editProduct.packagingType === "6" && (
                            <Col xs="12" md="4">
                                <Input
                                    name={"otherPackagingTypeTitle"}
                                    label={"Τίτλος για Λοιπά Είδη Συσκευασίας"}
                                    value={editProduct.otherPackagingTypeTitle}
                                    charLimit={150}
                                    className={"mb-2"}
                                    onChange={(e) => handleOnChange(e, "input", "otherPackagingTypeTitle")}
                                />
                            </Col>
                        )}
                    </Row>
                </Col>
            </Row>
            <hr/>
            <Row>
                <TextArea
                    name="notes"
                    rows="4"
                    autoComplete={"off"}
                    label={t('ProductsNewGeneralEdit.productNotes')}
                    value={editProduct.notes}
                    onChange={(e) => handleOnChange(e, "textarea", "notes")}
                />
            </Row>
            {editProduct.measurementUnit !== "4" && editProduct.isTaxLine !== "true" && (
                <Row>
                    <Col>
                        <EditableTable
                            heading="Installations Inventory"
                            tableName="Company Installations List"
                            key={"Installations Inventory Table"}
                            columns={inventoryInstallationsColumns}
                            data={editProduct.installationsInventory}
                            className="mb-4"
                        />
                    </Col>
                </Row>
            )}
            <Modal backdrop={"static"} show={showCategoryConfirmation}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('ProductsNewGeneral.warning')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{t('ProductsNewGeneral.warningMessage')}</Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary"
                            onClick={() => setShowCategoryConfirmation(false)}>{t('ProductsNewGeneral.no')}</Button>
                    <Button variant="primary"
                            onClick={() => handleConfirmCategory()}>{t('ProductsNewGeneral.yes')}</Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export const ProductsEditOthers = ({tabKey}) => {
    const {t} = useTranslation();
    const dispatch = useTaggedDispatch({tabKey});
    const editProduct = useSelector((state) => state.PRODUCTS_DATA.selectedEditProduct[tabKey]);
    const SETTINGS = useSelector(state => state.SETTINGS);
    const ACTIVITY = useSelector((state) => state.ACTIVITY);
    const permissionData = JSON.parse(localStorage.getItem("permissions"));

    const pMDDSettings = SETTINGS.primerMyDataData;
    const otherTaxes = [
        {value: "", label: t("Null")},
        ...getOptionsByData(pMDDSettings?.otherTaxes ? pMDDSettings.otherTaxes : SETTINGS.otherHoldTaxes, 'code', 'name')
    ];
    const taxesWithhold = [
        {value: "", label: t("Null")},
        ...getOptionsByData(pMDDSettings?.withHoldTaxes ? pMDDSettings.withHoldTaxes : SETTINGS.withHoldTaxes, 'code', 'name')
    ];
    const taxesStamp = [
        {value: "", label: t("Null")},
        ...getOptionsByData(pMDDSettings?.stamp ? pMDDSettings.stamp : SETTINGS.stamp, 'code', 'name'),
    ];
    const taxesFees = [
        {value: "", label: t("Null")},
        ...getOptionsByData(pMDDSettings?.fees ? pMDDSettings.fees : SETTINGS.fees, 'code', 'name'),
    ];

    const handleOnFieldChange = (e, name = '') => {
        if(!ACTIVITY.saveEditProduct) dispatch(setSaveEditProduct(true));

        let tax = {};
        tax[name] = e.value;
        let selectedProduct = Object.assign({}, editProduct);
        if (name === "otherTaxes") {
            const otherTax = findObjectFromArrayOfObjects(pMDDSettings.otherTaxes, e.value, 'code');
            if (otherTax && otherTax.taxAmount === "true") {
                selectedProduct.price = !isNaN(Number(otherTax.tax)) ? Number(otherTax.tax).toString() : "0";
                selectedProduct.isTaxLine = "true";
                if (otherTax.vatIncluded === 1 || otherTax.vatIncluded === 2) {
                    selectedProduct.isTaxLineWithoutVat = "false";
                    if (otherTax.vatIncluded === 2) {
                        selectedProduct.vatIncluded = false;
                    }
                    if (otherTax.vatPercentage !== 0) {
                        selectedProduct.vat = otherTax.vatPercentage.toString();
                    }
                } else {
                    selectedProduct.vat = "No VAT No VAT (π.χ. Μισθοδοσία, Αποσβέσεις κλπ)";
                    selectedProduct.isTaxLineWithoutVat = "true";
                }
                tax["withholdTax"] = "";
                tax["stamp"] = "";
                tax["fee"] = "";
                selectedProduct["measurementUnit"] = "1";
                dispatch(setSelectedEditProduct({selectedProduct}));
            } else {
                selectedProduct.isTaxLineWithoutVat = "false";
                selectedProduct.isTaxLine = "false";
                dispatch(setSelectedEditProduct({selectedProduct}));
            }
        } else if (name === "withholdTax") {
            const witholdTax = findObjectFromArrayOfObjects(pMDDSettings.withHoldTaxes, e.value, 'code');
            if (witholdTax && witholdTax.taxAmount === "true") {
                selectedProduct.price = !isNaN(Number(witholdTax.tax)) ? Number(witholdTax.tax).toString() : "0";
                selectedProduct.isTaxLine = "true";
                if (witholdTax.vatIncluded === 1 || witholdTax.vatIncluded === 2) {
                    selectedProduct.isTaxLineWithoutVat = "false";
                    if (witholdTax.vatIncluded === 2) {
                        selectedProduct.vatIncluded = false;
                    }
                    if (witholdTax.vatPercentage !== 0) {
                        selectedProduct.vat = witholdTax.vatPercentage.toString();
                    }
                } else {
                    selectedProduct.vat = "No VAT No VAT (π.χ. Μισθοδοσία, Αποσβέσεις κλπ)";
                    selectedProduct.isTaxLineWithoutVat = "true";
                }
                tax["otherTaxes"] = "";
                tax["stamp"] = "";
                tax["fees"] = "";
                tax["fee"] = "";
                selectedProduct["measurementUnit"] = "1";
                dispatch(setSelectedEditProduct({selectedProduct}));
            } else {
                selectedProduct.isTaxLineWithoutVat = "false";
                selectedProduct.isTaxLine = "false";
                dispatch(setSelectedEditProduct({selectedProduct}));
            }
        } else if (name === "fee") {
            const fee = findObjectFromArrayOfObjects(pMDDSettings.fees, e.value, 'code');
            if (fee && fee.taxAmount === "true") {
                selectedProduct.price = !isNaN(Number(fee.tax)) ? Number(fee.tax).toString() : "0";
                selectedProduct.isTaxLine = "true";
                if (fee.vatIncluded === 1 || fee.vatIncluded === 2) {
                    selectedProduct.isTaxLineWithoutVat = "false";
                    if (fee.vatIncluded === 2) {
                        selectedProduct.vatIncluded = false;
                    }
                    if (fee.vatPercentage !== 0) {
                        selectedProduct.vat = fee.vatPercentage.toString();
                    }
                } else {
                    selectedProduct.vat = "No VAT No VAT (π.χ. Μισθοδοσία, Αποσβέσεις κλπ)";
                    selectedProduct.isTaxLineWithoutVat = "true";
                }
                tax["otherTaxes"] = "";
                tax["stamp"] = "";
                tax["withholdTax"] = "";
                tax["fee"] = e.value;
                selectedProduct["measurementUnit"] = "1";
                dispatch(setSelectedEditProduct({selectedProduct}));
            } else {
                selectedProduct.isTaxLineWithoutVat = "false";
                selectedProduct.isTaxLine = "false";
                dispatch(setSelectedEditProduct({selectedProduct}));
            }
        } else if (name === "stamp") {
            const stamp = findObjectFromArrayOfObjects(pMDDSettings.stamp, e.value, 'code');
            if (stamp && stamp.taxAmount === "true") {
                selectedProduct.price = !isNaN(Number(stamp.tax)) ? Number(stamp.tax).toString() : "0";
                selectedProduct.isTaxLine = "true";
                if (stamp.vatIncluded === 1 || stamp.vatIncluded === 2) {
                    selectedProduct.isTaxLineWithoutVat = "false";
                    if (stamp.vatIncluded === 2) {
                        selectedProduct.vatIncluded = false;
                    }
                    if (stamp.vatPercentage !== 0) {
                        selectedProduct.vat = stamp.vatPercentage.toString();
                    }
                } else {
                    selectedProduct.vat = "No VAT No VAT (π.χ. Μισθοδοσία, Αποσβέσεις κλπ)";
                    selectedProduct.isTaxLineWithoutVat = "true";
                }
                tax["otherTaxes"] = "";
                tax["fee"] = "";
                tax["withholdTax"] = "";
                selectedProduct["measurementUnit"] = "1";
                dispatch(setSelectedEditProduct({selectedProduct}));
            } else {
                selectedProduct.isTaxLineWithoutVat = "false";
                selectedProduct.isTaxLine = "false";
                dispatch(setSelectedEditProduct({selectedProduct}));
            }
        }
        dispatch(setSelectedEditProduct({...selectedProduct, ...tax}));
    }

    const disabledFields = editProduct.category === undefined;

    return (
        <Row hidden={!checkPermission("products-products/edit-othertaxes-read", permissionData)}>
            <div className="position-relative product-form">
                <div className="text-muted mb-2"><i>{t('ProductsNewOtherTaxes.otherTaxes')}</i></div>
                {disabledFields && <div className="overlay_w">{t('ProductsNewOtherTaxes.message')}</div>}
                <Row className={"mb-2"}>
                    <Col md={3}>
                        <Dropdown
                            name={"otherTaxes"}
                            label={t('ProductsSettings.otherTaxes')}
                            key={Math.random()}
                            defaultValue={otherTaxes.find((el) => el.value === editProduct.otherTaxes)}
                            options={otherTaxes}
                            onChange={(e) => handleOnFieldChange(e, 'otherTaxes')}
                        />
                    </Col>
                    <Col md={3}>
                        <Dropdown
                            name={"withholdTax"}
                            label={t('ProductsSettings.withHoldTaxes')}
                            key={Math.random()}
                            defaultValue={taxesWithhold.find((el) => el.value === editProduct.withholdTax)}
                            options={taxesWithhold}
                            onChange={(e) => handleOnFieldChange(e, 'withholdTax')}
                        />
                    </Col>
                    <Col md={3}>
                        <Dropdown
                            name={"stamp"}
                            label={t('ProductsSettings.stamp')}
                            key={Math.random()}
                            defaultValue={taxesStamp.find((el) => el.value === editProduct.stamp)}
                            options={taxesStamp}
                            onChange={(e) => handleOnFieldChange(e, 'stamp')}
                        />
                    </Col>
                    <Col md={3}>
                        <Dropdown
                            name={"fee"}
                            label={t('ProductsSettings.fees')}
                            key={Math.random()}
                            defaultValue={taxesFees.find((el) => el.value === editProduct.fee)}
                            options={taxesFees}
                            onChange={(e) => handleOnFieldChange(e, 'fee')}
                        />
                    </Col>
                </Row>
                <p className="mb-4">{t('ProductsNewOtherTaxes.message2')}</p>
            </div>
        </Row>
    )
}

export const ProductsEditAccounting = ({tabKey}) => {
    const {t} = useTranslation();
    const ACTIVITY = useSelector((state) => state.ACTIVITY);
    const dispatch = useTaggedDispatch({tabKey});
    const editProduct = useSelector((state) => state.PRODUCTS_DATA.selectedEditProduct[tabKey]);
    const [incrKey2, setIncrKey2] = useState(0);
    useEffect(() => {
        setIncrKey2(incrKey2 + 1);
    }, [editProduct]);

    const handleOnChange = (e, type, compName) => {
        if(!ACTIVITY.saveEditProduct) dispatch(setSaveEditProduct(true));

        if (type === "input") {
            if (compName === "permanentAnamorfosiPercent") {
                let value = e.target.value;
                if (Number(value) < 0) value = 0;
                if (Number(value) > 100) value = 100;
                dispatch(setSelectedEditProduct({...editProduct, [compName] : value}));
            } else {
                dispatch(setSelectedEditProduct({...editProduct, [compName] : e.target.value}));
            }
        } else if (type === "checkbox") {
            dispatch(setSelectedEditProduct({...editProduct, [compName] : e.target.checked === true ? "active" : "inactive"}));
        }
    }
    return (
        <React.Fragment>
            <div className="text-muted mb-2"><i>{t('ProductsNewAccounting.accounting')}</i></div>
            <Row>
                <Col xs="12" md="4">
                    <Input
                        name="accountingCode"
                        className="mb-3"
                        charLimit={20}
                        placeholder="Εισάγετε Πρόθεμα Κωδικού Λογαριασμού"
                        label="Πρόθεμα Κωδικού Λογαριασμού"
                        value={editProduct.accountingCode}
                        onChange={(e) => handleOnChange(e, "input", "accountingCode")}
                    />
                </Col>
                <Col md={4}>
                    <BetterCheckBox
                        name={"accountingNonDeductibleVAT"}
                        className={"mt-4"}
                        text={"Μη Εκπιπτόμενος Φ.Π.Α."}
                        checked={editProduct.accountingNonDeductibleVAT === "active"}
                        onChange={(e) => handleOnChange(e, "checkbox", "accountingNonDeductibleVAT")}
                    />
                </Col>
            </Row>
            <Col md={2}>
                <label>Ποσοστιαία Αναμόρφωση Είδους</label>
                <AccountingBox
                    suffix={"%"}
                    name={"permanentAnamorfosiPercent"}
                    value={editProduct.permanentAnamorfosiPercent}
                    defaultValue={editProduct.permanentAnamorfosiPercent}
                    key={incrKey2}
                    onBlur={(e) => handleOnChange(e, "input", "permanentAnamorfosiPercent")}
                />
            </Col>
            <Row>
                <div className="text-muted mb-2"><i>{t("General.bypassAccounting")}:</i></div>
                <Col xs="12" md="4">
                    <Input
                        name="netAmountAccountingCode"
                        className="mb-3"
                        charLimit={20}
                        placeholder="Εισάγετε Κωδικό Λογαριασμού Καθαρής Αξίας"
                        label="Κωδικός Λογαριασμού Καθαρής Αξίας"
                        value={editProduct.netAmountAccountingCode}
                        onChange={(e) => handleOnChange(e, "input", "netAmountAccountingCode")}
                    />
                </Col>
                <Col xs="12" md="4">
                    <Input
                        name="vatAccountingCode"
                        className="mb-3"
                        charLimit={20}
                        placeholder="Εισάγετε Κωδικό Λογαριασμού ΦΠΑ"
                        label="Κωδικός Λογαριασμού ΦΠΑ"
                        value={editProduct.vatAccountingCode}
                        onChange={(e) => handleOnChange(e, "input", "vatAccountingCode")}
                    />
                </Col>
                <Col xs="12" md="4">
                    <Input
                        name={"taxAccountCode"}
                        className={"mb-3"}
                        charLimit={20}
                        placeholder={"Εισάγετε Κωδικό Λογαριασμού Φόρου"}
                        label={"Κωδικός λογαριασμού Φόρου"}
                        value={editProduct.taxAccountCode}
                        onChange={(e) => handleOnChange(e, "input", "taxAccountCode")}
                    />
                </Col>
            </Row>
            <Row>
                <div className="text-muted mb-2"><i>Ρυθμίσεις Λογιστικής για Πωλήσεις</i></div>
                <Col xs="12" md="3">
                    <Input
                        name="accountingCodeSales"
                        className="mb-3"
                        charLimit={20}
                        placeholder="Εισάγετε Πρόθεμα Κωδικού Λογαριασμού"
                        label="Πρόθεμα Κωδικού Λογαριασμού"
                        value={editProduct.accountingCodeSales}
                        onChange={(e) => handleOnChange(e, "input", "accountingCodeSales")}
                    />
                </Col>
                <Col xs="12" md="3">
                    <Input
                        name="netAmountAccountingCodeSales"
                        className="mb-3"
                        charLimit={20}
                        placeholder="Εισάγετε Κωδικό Λογαριασμού Παράκαμψης Καθαρής Αξίας"
                        label="Κωδικός Λογαριασμού Παράκαμψης Καθαρής Αξίας"
                        value={editProduct.netAmountAccountingCodeSales}
                        onChange={(e) => handleOnChange(e, "input", "netAmountAccountingCodeSales")}
                    />
                </Col>
                <Col xs="12" md="3">
                    <Input
                        name="vatAccountingCodeSales"
                        className="mb-3"
                        charLimit={20}
                        placeholder="Εισάγετε Κωδικό Λογαριασμού Παράκαμψης ΦΠΑ"
                        label="Κωδικός Λογαριασμού Παράκαμψης ΦΠΑ"
                        value={editProduct.vatAccountingCodeSales}
                        onChange={(e) => handleOnChange(e, "input", "vatAccountingCodeSales")}
                    />
                </Col>
                <Col xs="12" md="3">
                    <Input
                        name={"taxAccountCodeSales"}
                        className={"mb-3"}
                        charLimit={20}
                        placeholder={"Εισάγετε Κωδικό Λογαριασμού Παράκαμψης Φόρου"}
                        label={"Κωδικός λογαριασμού Παράκαμψης Φόρου"}
                        value={editProduct.taxAccountCodeSales}
                        onChange={(e) => handleOnChange(e, "input", "taxAccountCodeSales")}
                    />
                </Col>
            </Row>
            <Row>
                <div className="text-muted mb-2"><i>Ρυθμίσεις Λογιστικής για Αγορές</i></div>
                <Col xs="12" md="3">
                    <Input
                        name="accountingCodeBuys"
                        className="mb-3"
                        charLimit={20}
                        placeholder="Εισάγετε Πρόθεμα Κωδικού Λογαριασμού"
                        label="Πρόθεμα Κωδικού Λογαριασμού"
                        value={editProduct.accountingCodeBuys}
                        onChange={(e) => handleOnChange(e, "input", "accountingCodeBuys")}
                    />
                </Col>
                <Col xs="12" md="3">
                    <Input
                        name="netAmountAccountingCodeBuys"
                        className="mb-3"
                        charLimit={20}
                        placeholder="Εισάγετε Κωδικό Λογαριασμού Παράκαμψης Καθαρής Αξίας"
                        label="Κωδικός Λογαριασμού Παράκαμψης Καθαρής Αξίας"
                        value={editProduct.netAmountAccountingCodeBuys}
                        onChange={(e) => handleOnChange(e, "input", "netAmountAccountingCodeBuys")}
                    />
                </Col>
                <Col xs="12" md="3">
                    <Input
                        name="vatAccountingCodeBuys"
                        className="mb-3"
                        charLimit={20}
                        placeholder="Εισάγετε Κωδικό Λογαριασμού Παράκαμψης ΦΠΑ"
                        label="Κωδικός Λογαριασμού Παράκαμψης ΦΠΑ"
                        value={editProduct.vatAccountingCodeBuys}
                        onChange={(e) => handleOnChange(e, "input", "vatAccountingCodeBuys")}
                    />
                </Col>
                <Col xs="12" md="3">
                    <Input
                        name={"taxAccountCodeBuys"}
                        className={"mb-3"}
                        charLimit={20}
                        placeholder={"Εισάγετε Κωδικό Λογαριασμού Παράκαμψης Φόρου"}
                        label={"Κωδικός λογαριασμού Παράκαμψης Φόρου"}
                        value={editProduct.taxAccountCodeBuys}
                        onChange={(e) => handleOnChange(e, "input", "taxAccountCodeBuys")}
                    />
                </Col>
            </Row>
        </React.Fragment>
    );
};

export const ProductsEditProductCodes = ({tabKey}) => {
    const {t} = useTranslation();
    const dispatch = useTaggedDispatch({tabKey});
    const editProduct = useSelector((state) => state.PRODUCTS_DATA.selectedEditProduct[tabKey]);
    const ACTIVITY = useSelector((state) => state.ACTIVITY);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const permissionData = JSON.parse(localStorage.getItem("permissions"));
    const [supplierData, setSupplierData] = useState([]);

    const [incrKey, setIncrKey] = useState(0);

    useEffect(() => {
        loadSuppliers(null, null, setSupplierData);
    }, []);

    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [editProduct?.productCodes, supplierData]);

    const parentProductCodes = {
        insert: (e, data) => {
            if (!ACTIVITY.saveEditProduct) dispatch(setSaveEditProduct(true));

            if (data.field === "supplierName") {
                const cloneData = editProduct.productCodes.slice() || [];
                const initRow = {
                    no: String(cloneData.length + 1),
                    productName: "",
                    productCode: "",
                    supplier: e.row._id,
                    supplierName: e.row.name,
                }
                cloneData.push(initRow);
                dispatch(setEditProductCodes(cloneData));
            }
        },
        update: (data, id, rowIndex) => {
            if (!ACTIVITY.saveEditProduct) dispatch(setSaveEditProduct(true));

            const cloneData = quickClone(editProduct.productCodes);
            cloneData[rowIndex] = {...cloneData[rowIndex], ...data};
            dispatch(setEditProductCodes(cloneData));
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!ACTIVITY.saveEditProduct) dispatch(setSaveEditProduct(true));

            const productCodes = structuredClone(editProduct.productCodes);
            productCodes.splice(rowIndex, 1);
            productCodes.forEach((row, idx) => {
                row.no = String(idx + 1);
            })
            dispatch(setEditProductCodes(productCodes));
        }
    }

    const supplierCodeColumns = [
        {label: t("General.code"), name: "systemCode"},
        {label: t("General.name"), name: "name"},
        {label: t('General.vatNumber'), name: "vatNumber"},
    ];

    const loadSuppliers = (cellName, keyword, setData) => {
        const reqData = {
            company: company.id,
            subAccountType: "supplier",
            keyword: keyword,
        }
        axios.get(process.env.REACT_APP_API_URL2 + `/accounting/get-subAccount-by-word`, {
            params: reqData
        }).then(res => {
            if (res.data && res.data.status === '200') {
                if (res.data.data) {
                    if (setData) setData(res.data.data);
                } else {
                    if (setData) setData([]);
                }
            } else {
                if (setData) setData([]);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const productCodesColumns = [
        {
            name: "Αρ.",
            field: "no",
            width: "5%",
        },
        {
            name: t('ProductsNewTags.table.supplier'),
            field: "supplierName",
            editable: true,
            width: "35%",
            inputType: {
                config: {
                    excludeColumns: [],
                    columns: supplierCodeColumns,
                    data: supplierData,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: t('ProductsNewTags.table.selectSupplierName'),
                    onChangeSearchCell: loadSuppliers,
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: t('ProductsNewTags.table.productName'),
            field: "productName",
            editable: true,
            width: "30%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ProductsNewTags.table.productCode'),
            field: "productCode",
            editable: true,
            width: "30%",
            inputType: {
                type: 'text',
            }
        },
    ];

    return (
        <React.Fragment>
            <Row hidden={!checkPermission("products-products/edit-tags-read", permissionData)}>
                <EditableTable
                    key={incrKey}
                    heading={t('ProductsNewTags.productCodes')}
                    tableName="Product Codes"
                    columns={productCodesColumns}
                    allowActions={true}
                    allowInsertRow={true}
                    data={editProduct.productCodes}
                    enableNewRowCheckbox={true}
                    onUpdate={parentProductCodes}
                />
            </Row>
        </React.Fragment>
    )
}

export const ProductsEditVariants = ({tabKey}) => {
    const {t} = useTranslation();
    const dispatch = useTaggedDispatch({tabKey});
    const editProduct = useSelector((state) => state.PRODUCTS_DATA.selectedEditProduct[tabKey]);
    const PRODUCTS_DATA = useSelector((state) => state.PRODUCTS_DATA);
    const [variantPropertiesOptions, setVariantPropertiesOptions] = useState([]);
    const [variantName, setVariantName] = useState(editProduct.name);
    const [showVariantModal, setShowVariantModal] = useState(false);
    const [showAutoCreateModal, setShowAutoCreateModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showDeleteMultipleModal, setShowDeleteMultipleModal] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);

    const handleSelect = (e, type, dataKey) => {
        if (type === "selectRow") {
            const selectedRows = Array.from(PRODUCTS_DATA.selectedEditVariantsRows);
            if (selectedRows.includes(dataKey)) {
                selectedRows.splice(selectedRows.indexOf(dataKey), 1);
            } else {
                selectedRows.push(dataKey);
            }
            dispatch(setEditSelectedVariantsRows(selectedRows));
        } else if (type === "selectAll") {
            if (!PRODUCTS_DATA.allCheckedEditVariants) {
                dispatch(setEditSelectedVariantsRows(Array.from({ length: editProduct.displayedVariants.length }, (v, index) => index)));
                dispatch(setAllCheckedEditVariants(true));
            } else {
                dispatch(setEditSelectedVariantsRows([]));
                dispatch(setAllCheckedEditVariants(false));
            }
        }
    }

    const variantColumns = [
        {
            field: "select_checkbox",
            name: "Select All",
            width: "40px",
            inputType: {
                type: 'selection',
                select: handleSelect
            }
        },{
            name: 'Ονομασία',
            field: "name",
            width: "20%",
            editable: false,
            inputType: {
                type: 'text',
            }
        },{
            name: 'Ιδιότητες',
            field: "properties",
            width: "40%",
            editable: false,
            inputType: {
                type: 'text',
            }
        },{
            name: 'SKU',
            field: "sku",
            width: "20%",
            editable: false,
            inputType: {
                type: 'text',
            }
        },{
            name: 'Απόθεμα',
            field: "inventoryBalance",
            width: "10%",
            editable: false,
            inputType: {
                type: 'text',
            }
        },{
            name: 'Τιμή',
            field: "totalPrice",
            width: "10%",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
    ];

    useEffect(() => {
        dispatch(setEditVariantIds());
        dispatch(setEditVariantSearchTerm(""));
        editProduct.productProperties?.forEach((property) => {
            if (property.values.length === 0) return;
            let options = property.values.split(",");

            options = [...new Set(options)]; //Remove duplicates

            // Create property options including price variations
            options = options.map((opt) => {
                let priceVariation;
                if (opt.includes(":") && isValidNumber(opt.split(":")[1])) {
                    let temp = opt.split(":")[1].trim();
                    priceVariation = temp > 0 ? `+${temp}€` : temp < 0 ? `${temp}€` : "";
                    opt = opt.split(":")[0].trim();
                    return {label: `${opt} ${priceVariation}`, value: opt.trim(), priceVariation: temp};
                }
                return  {label: opt, value: opt.trim()};
            });
            options.unshift({label: "Κενό", value: null});
            setVariantPropertiesOptions(oldArr =>[...oldArr, {name: property.name, options: options}]);
        });
    }, []);

    useEffect(() => {
        const props = PRODUCTS_DATA.newVariant.properties;
        setVariantName(`${editProduct.name}  ${Object.values(props).filter((el) => el !== null).join(" - ")}`);
        const priceVariationSum = Object.values(PRODUCTS_DATA.newVariant.priceVariations ?? {}).reduce((a = 0, b = 0) => Number(a) + Number(b), 0);
        const price = Number(PRODUCTS_DATA.newVariant.price);
        const totalPrice = price + priceVariationSum;
        dispatch(setNewVariant({...PRODUCTS_DATA.newVariant, price: price, totalPrice: totalPrice}))
    }, [PRODUCTS_DATA.newVariant.properties]);

    const handleOnChange = (e, type="default", name="") => {
        let newVariantData = structuredClone(PRODUCTS_DATA.newVariant);
        if (type === "property") {
            newVariantData["properties"][name] = e.value;
            if(e.priceVariation) newVariantData["priceVariations"][name] = e.priceVariation;
            else delete newVariantData["priceVariations"][name];
        } else if (type === "input" || type === "accountingBox") {
            newVariantData[name] = e.target.value;
        } else if (type === "checkbox") {
            newVariantData[name] = e.target.value;
        }
        dispatch(setNewVariant({...PRODUCTS_DATA.newVariant, ...newVariantData}));
    }

    const addVariant = () => {
        let newVariant = structuredClone(PRODUCTS_DATA.newVariant);
        let productVariants = structuredClone(editProduct.variants);

        if (newVariant.name.length === 0) newVariant.name = variantName;
        newVariant.id = productVariants.length;

        removeEmptyValues(newVariant.properties);
        if (isEmpty(newVariant.properties) || Object.values(newVariant.properties).every(value => value === null)) {
            return toast.error("Οι παραλλαγές πρέπει να έχουν τουλάχιστον μια ιδιότητα.");
        }
        let isDuplicate = false;
        productVariants.forEach((element) => {
            if(JSON.stringify(element.properties) === JSON.stringify(newVariant.properties)) isDuplicate = true;
        });
        if (isDuplicate) {
            return toast.error("Υπάρχει ήδη παραλλαγή με ίδιες ιδιότητες.");
        }
        productVariants.push(newVariant);

        dispatch(addProductEditVariant(newVariant));
        dispatch(setSaveEditProduct(true));
        setShowVariantModal(false);
        toast.success("Προστέθηκε νέα παραλλαγή.");
    }

    const editVariant = () => {
        let newVariant = structuredClone(PRODUCTS_DATA.newVariant);
        let productVariants = structuredClone(editProduct.variants);
        let displayedVariants = structuredClone(editProduct.displayedVariants);

        if (newVariant.name.length === 0) newVariant.name = variantName;

        removeEmptyValues(newVariant.properties);
        if (isEmpty(newVariant.properties) || Object.values(newVariant.properties).every(value => value === null)) {
            return toast.error("Οι παραλλαγές πρέπει να έχουν τουλάχιστον μια ιδιότητα.");
        }
        const index1 = productVariants.findIndex(obj => obj.id === newVariant.id);
        const index2 = displayedVariants.findIndex(obj => obj.id === newVariant.id);
        if (index1 !== -1) productVariants[index1] = newVariant;
        if (index2 !== -1) displayedVariants[index2] = newVariant;

        dispatch(updateProductEditVariants(productVariants));
        dispatch(setEditProductDisplayedVariants(displayedVariants));
        dispatch(setSaveEditProduct(true));
        setShowVariantModal(false);
        toast.success("Προστέθηκε νέα παραλλαγή.");
    }

    const createNewVariant = () => {
        const startingPrice = Number(editProduct.price);
        dispatch(setNewVariant({...PRODUCTS_DATA.newVariantInitialValue, price: startingPrice, totalPrice: startingPrice}));
        setShowVariantModal(true);
    }

    const variantTableActions =  {
        insert: () => {},
        update: () => {},
        selected: (data) => {
            dispatch(setNewVariant(data));
            setShowVariantModal(true);
        },
        delete: (id, rowIndex) => {
            setDeleteIndex(rowIndex)
            setShowDeleteModal(true);
        },
    }

    const handleDelete = () => {
        let displayedVariants = structuredClone(editProduct.displayedVariants);
        let variants = structuredClone(editProduct.variants);

        const deleted = displayedVariants.splice(deleteIndex, 1);
        if (!isEmpty(deleted)) variants = variants.filter(variant => variant.id !== deleted[0].id);

        dispatch(updateProductEditVariants(variants));
        dispatch(setEditProductDisplayedVariants(displayedVariants));
        setShowDeleteModal(false);
        dispatch(setSaveEditProduct(true));
    }

    const handleDeleteMany = () => {
        let displayedVariants = structuredClone(editProduct.displayedVariants);
        let variants = structuredClone(editProduct.variants);
        const selectedEditVariantsRows = structuredClone(PRODUCTS_DATA.selectedEditVariantsRows);
        let deletedIds = [];
        selectedEditVariantsRows.sort((x, y) => y - x);

        selectedEditVariantsRows.forEach((selIndex) => {
            let deleted = displayedVariants.splice(selIndex, 1);
            if (!isEmpty(deleted)) deletedIds.push(deleted[0].id);
        });
        variants = variants.filter((variant) => {
            return !deletedIds.includes(variant.id);
        });
        setShowDeleteMultipleModal(false);
        dispatch(setEditSelectedVariantsRows([]));
        dispatch(setAllCheckedEditVariants(false))
        dispatch(setEditProductDisplayedVariants(displayedVariants));
        dispatch(updateProductEditVariants(variants));
        dispatch(setSaveEditProduct(true));
    }

    const autoCreateVariants = () => {
        const productProperties = structuredClone(editProduct.productProperties);
        const startingPrice = Number(editProduct.price);
        const arrays = productProperties.map((prop) => prop.values.split(",").map(val => { return {[prop.name]: val} }));
        const variants = [];
        let createdCount = 0;

        function createCombos(currentProps, index) {
            if (index === arrays.length) {
                let priceVariation = 0;
                let priceVariations = {};
                let tempCurrentProps = structuredClone(currentProps);
                tempCurrentProps.forEach((prop) => {
                    Object.keys(prop).forEach((key) => {
                        let temp = prop[key].split(":");
                        prop[key] = temp[0].trim();
                        if (temp.length === 2 && isValidNumber(temp[1])) {
                            priceVariation += Number(temp[1]);
                            priceVariations[key] = temp[1];
                        }
                    });
                });
                // Merge all props
                const combinedProps = Object.assign({}, ...tempCurrentProps);

                let alreadyExists = false;
                editProduct.variants?.forEach((variant) => {
                    if(JSON.stringify(variant.properties) === JSON.stringify(combinedProps)) {
                        alreadyExists = true;
                    }
                });
                if (alreadyExists) return;

                let variantName = `${editProduct.name}  ${Object.values(combinedProps).filter((el) => el !== null).join(" - ")}`;
                const newVariant = {...PRODUCTS_DATA.newVariantInitialValue, name: variantName, properties: combinedProps, priceVariations: priceVariations, price: startingPrice, totalPrice: startingPrice + priceVariation};
                variants.push(newVariant);
                createdCount++
                return;
            }

            for (let i = 0; i < arrays[index].length; i++) {
                createCombos(currentProps.concat(arrays[index][i]), index + 1);
            }
        }
        createCombos([], 0);

        dispatch(addProductEditAllVariants(variants));
        dispatch(setEditVariantIds());
        dispatch(setSaveEditProduct(true));
        setShowAutoCreateModal(false);
        createdCount !== 0 ? toast.success(`Δημιουργήθηκαν ${createdCount} παραλλαγές επιτυχώς.`) : toast.info("Έχουν ήδη δημιουργηθεί όλες οι πιθανές παραλλαγές.");
    }

    const searchTermOnChange = (e) => {
        const term = e.target.value;
        const regex = /[{},:.]/g;
        dispatch(setEditVariantSearchTerm(term));

        const termRegex = new RegExp(normalizeText(term), 'gi');
        let result = editProduct.variants?.filter((variant) => {
            const variantName = normalizeText(variant.name);
            const variantProps = normalizeText(JSON.stringify(variant.properties).replace(regex));
            return variantName.match(termRegex) || variantProps.match(termRegex);
        });
        dispatch(setEditProductDisplayedVariants(result));
    }

    return (
        <React.Fragment>
            <Row>
                <Col xs="12" md="4" className="mb-2">
                    <Input
                        name="search"
                        charLimit={100}
                        placeholder="Αναζήτηση"
                        autoComplete="off"
                        onChange={(e) => searchTermOnChange(e)}
                        value={PRODUCTS_DATA.editVariantSearchTerm}
                    />
                </Col>
                <Col xs="12" md="8" className="mb-2">
                    <div className="float-right">
                        <Button hidden={PRODUCTS_DATA.selectedEditVariantsRows.length === 0} type="button"
                                onClick={() => setShowDeleteMultipleModal(true)}
                                className="btn btn-primary mb-2 mr-2">Διαγραφή επιλεγμένων</Button>
                        <Button disabled={variantPropertiesOptions.length === 0} type="button" onClick={() => setShowAutoCreateModal(true)}
                                className="btn btn-primary mb-2 mr-2">Αυτόματη Δημιουργία</Button>
                        <Button disabled={variantPropertiesOptions.length === 0} type="button" onClick={createNewVariant}
                                className="btn btn-primary mb-2">Νέα Παραλλαγή</Button>
                    </div>
                </Col>
            </Row>
            <Modal backdrop={"static"} show={showVariantModal} onEscapeKeyDown={() => setShowVariantModal(false)} onHide={() => setShowVariantModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{PRODUCTS_DATA.newVariant.id == null ? <strong>Νέα Παραλλαγή</strong> : <strong>Επεξεργασία: {PRODUCTS_DATA.newVariant.name}</strong>}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="position-relative border-bottom mb-3 d-flex align-items-center px-2">
                        {editProduct.measurementUnit !== "4" && PRODUCTS_DATA.newVariant.id != null && (
                            <Col xs="12" md="6" className="mr-auto">
                                <div className="inline-field d-flex align-items-center mb-3">
                                    <label htmlFor="variantInventoryBalance" className="mr-2 mb-0 w-100 ">{"Υπόλοιπο Αποθέματος Παραλλαγής:"}</label>
                                    <Input
                                        name="variantInventoryBalance"
                                        charLimit={50}
                                        type={"number"}
                                        disabled={true}
                                        className="d-flex align-items-center w-100"
                                        value={PRODUCTS_DATA.newVariant.inventoryBalance ?? 0}
                                    />
                                </div>
                            </Col>
                        )}
                        <Col xs="12" md="4" className={`d-flex align-items-center ${PRODUCTS_DATA.newVariant.id != null && "justify-content-end"}`}>
                            <div className="inline-field d-flex align-items-center mb-3">
                                <label htmlFor="variant-active" className="mb-0 mr-2">{"Ενεργή Παραλλαγή"}</label>
                                <Checkbox
                                    className="mb-2"
                                    name="isActive"
                                    key={Math.random()}
                                    id="variant-active"
                                    defaultValue={PRODUCTS_DATA.newVariant.isActive}
                                    value={PRODUCTS_DATA.newVariant.isActive === 'active' ? "inactive" : "active"}
                                    onChange={(e) => handleOnChange(e, "checkbox", "isActive")}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        {
                            variantPropertiesOptions.map((property) => {
                                let defaultValue = PRODUCTS_DATA["newVariant"]["properties"][property.name];
                                return (
                                    <Col md={6}>
                                        <Dropdown
                                            name={property.name}
                                            label={<strong>{property.name}</strong>}
                                            key={Math.random()}
                                            options={property.options}
                                            defaultValue={defaultValue ? {label: defaultValue, value: defaultValue} : {label: t("General.empty"), value: null}}
                                            enabledValue={true}
                                            disabled={PRODUCTS_DATA.newVariant.id != null}
                                            onChange={(e) => handleOnChange(e, "property", property.name)}
                                        />
                                    </Col>
                                )
                            })
                        }
                    </Row>
                    <Row>
                        <Col xs="12" md="12">
                            <div className="mb-3">
                                <Input
                                    name="name"
                                    charLimit={200}
                                    placeholder={variantName}
                                    label={t('General.name')}
                                    autoComplete="off"
                                    onChange={(e) => handleOnChange(e, 'input', 'name')}
                                    value={PRODUCTS_DATA.newVariant.name}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12" md="12">
                            <div className="mb-3">
                                <Input
                                    name="sku"
                                    charLimit={100}
                                    placeholder="SKU"
                                    label="SKU"
                                    autoComplete="off"
                                    onChange={(e) => handleOnChange(e, 'input', 'sku')}
                                    value={PRODUCTS_DATA.newVariant.sku}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12" md="6">
                            <div className="mb-3">
                                <FormLabel className="" htmlFor="price">{t('ProductsNewGeneral.preferredPrice.preferredPrice')}</FormLabel>
                                <AccountingBox
                                    name="price"
                                    defaultValue={PRODUCTS_DATA.newVariant.price}
                                    onChange={(e) => handleOnChange(e, 'accountingBox', 'price')}
                                />
                            </div>
                        </Col>
                        <Col xs="12" md="6">
                            <div className="mb-3">
                                <FormLabel className="" htmlFor="price">{t('General.totalPrice')}</FormLabel>
                                <AccountingBox
                                    name="totalPrice"
                                    disabled={true}
                                    defaultValue={PRODUCTS_DATA.newVariant.totalPrice}
                                />
                            </div>
                            <div>
                                {
                                    Object.entries(PRODUCTS_DATA.newVariant.priceVariations ?? {}).map(([key, val]) => {
                                        return (<div className="mb-2">{`${key}: ${val > 0 ? `+${val}€` : val < 0 ? `${val}€` : ""}`}</div>)
                                    })
                                }
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowVariantModal(false)}>
                        Κλείσιμο
                    </Button>
                    {PRODUCTS_DATA.newVariant.id == null ?
                        <Button disabled={variantPropertiesOptions.length === 0} type="button" onClick={addVariant}
                                className="btn btn-primary mb-2 ml-2 float-right">Δημιουργία Παραλλαγής</Button>
                        :
                        <Button disabled={variantPropertiesOptions.length === 0} type="button" onClick={editVariant}
                                className="btn btn-primary mb-2 ml-2 float-right">Ενημέρωση Παραλλαγής</Button>
                    }
                </Modal.Footer>
            </Modal>
            {/*DELETE CONFIRM*/}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header>
                    <Modal.Title>{t('ProductVariants.delete')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t('ProductVariants.confirmDelete')}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        onClick={handleDelete}
                    >
                        {t('DataPanelIndex.yes')}
                    </Button>
                    <Button
                        variant="outline-primary"
                        onClick={() => setShowDeleteModal(false)}
                    >
                        {t('DataPanelIndex.no')}
                    </Button>
                </Modal.Footer>
            </Modal>
            {/*DELETE MULTIPLE CONFIRM*/}
            <Modal show={showDeleteMultipleModal} onHide={() => setShowDeleteMultipleModal(false)}>
                <Modal.Header>
                    <Modal.Title>{t('ProductVariants.deleteMultiple')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t('ProductVariants.confirmDeleteMultiple')}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        onClick={handleDeleteMany}
                    >
                        {t('DataPanelIndex.yes')}
                    </Button>
                    <Button
                        variant="outline-primary"
                        onClick={() => setShowDeleteMultipleModal(false)}
                    >
                        {t('DataPanelIndex.no')}
                    </Button>
                </Modal.Footer>
            </Modal>
            {/*AUTO CREATE CONFIRM*/}
            <Modal show={showAutoCreateModal} onHide={() => setShowAutoCreateModal(false)}>
                <Modal.Header>
                    <Modal.Title>{t('ProductVariants.autoCreate')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t('ProductVariants.confirmAutoCreate')}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        onClick={autoCreateVariants}
                    >
                        {t('DataPanelIndex.create')}
                    </Button>
                    <Button
                        variant="outline-primary"
                        onClick={() => setShowAutoCreateModal(false)}
                    >
                        {t('DataPanelIndex.cancel')}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Row>
                <Col md={12}>
                    <EditableTable
                        key={Math.random()}
                        heading={"Πίνακας Παραλλαγών Είδους"}
                        tableName="Product Variants"
                        columns={variantColumns}
                        allowActions={true}
                        allowInsertRow={false}
                        enableNewRowCheckbox = {false}
                        data={editProduct.displayedVariants}
                        onUpdate={variantTableActions}
                        selectedRows={PRODUCTS_DATA.selectedEditVariantsRows}
                        allChecked={PRODUCTS_DATA.allCheckedEditVariants}
                    />
                </Col>
            </Row>
        </React.Fragment>
    );
};

export const ProductsEditLog = ({tabKey}) => {
    const {t} = useTranslation();
    const editProduct = useSelector((state) => state.PRODUCTS_DATA.selectedEditProduct[tabKey]);

    return (
        <React.Fragment>
            <div className="text-muted mb-2"><i>{t('Logs.productLog')}</i></div>
            <LogTable itemId={editProduct._id}/>
        </React.Fragment>
    )
}
